import type { Configuration } from "@azure/msal-browser"

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID || "YOUR_CLIENT_ID",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_TENANT_ID || "YOUR_TENANT_ID"}`,
    redirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
}

// Updated scopes with all required permissions
export const loginRequest = {
  scopes: [
    "https://analysis.windows.net/powerbi/api/Report.Read.All",
    "https://analysis.windows.net/powerbi/api/Dataset.Read.All",
    "https://analysis.windows.net/powerbi/api/Group.Read.All",
    "https://analysis.windows.net/powerbi/api/Content.Create",
    "https://analysis.windows.net/powerbi/api/Workspace.Read.All",
  ],
}

// Alternative scopes if the above doesn't work
export const alternativeLoginRequest = {
  scopes: ["https://analysis.windows.net/powerbi/api/.default"],
}

export const powerBiConfig = {
  apiUrl: "https://api.powerbi.com/v1.0/myorg",
  workspaceId: process.env.REACT_APP_WORKSPACE_ID || "YOUR_WORKSPACE_ID",
  reportId: process.env.REACT_APP_REPORT_ID || "YOUR_REPORT_ID",
}
